import React from 'react';
import HackathonRegistration from '../../../components/hackathon/HackathonRegistration';
import TetrisBackground from '../../../components/hackathon/TetrisBackground';
import { Link } from '@tanstack/react-router';
import HackathonFooter from '../../../components/hackathon/HackathonFooter';

const HackathonRegisterPage: React.FC = () => {
  return (
    <div className="relative min-h-screen overflow-hidden">
      <TetrisBackground />
      <div className="absolute inset-0 bg-white/80 backdrop-blur-sm" />
      <div className="relative z-10">
        <div className="border-b border-slate-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <Link
                to="/hackathon"
                className="inline-flex items-center text-slate-600 hover:text-slate-900 transition-colors"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Back
              </Link>
              <h1 className="text-xl font-extrabold tracking-tight text-slate-900">
                WaldHacks 2025
              </h1>
              <div className="w-20" /> {/* Spacer for balance */}
            </div>
          </div>
        </div>
        <HackathonRegistration />
        <HackathonFooter />
      </div>
    </div>
  );
};

export default HackathonRegisterPage; 